/** Libellé affiché pour un ticket « Nous écrire ». */
export function adminSuggestionKind(s) {
  const rawType = String(s?.suggestion_type || "").trim().toLowerCase();
  if (rawType === "question") return "Question";
  if (rawType === "bug") return "Bug";
  return "Suggestion";
}

/** Construit un lien mailto pour répondre à un ticket support. */
export function buildAdminSuggestionMailto(s) {
  const adminKind = adminSuggestionKind(s);
  const email = String(s?._admin_display_email || s?.email || "").trim();
  const displayName = String(s?._admin_display_name || "").trim();
  const when = s?.created_at ? new Date(s.created_at).toLocaleString("fr-FR") : "";
  const products = s?.suggested_products ? String(s.suggested_products) : "";
  const subjectBase = `RdvMarket — ${adminKind}${products && adminKind === "Suggestion" ? ` — ${products}` : ""}`;
  const body = [
    "Bonjour,",
    "",
    "Merci pour votre message sur RdvMarket.",
    "",
    "--- Message original ---",
    `Date : ${when || "—"}`,
    `Contexte : ${s?.context || "—"}`,
    displayName ? `Nom affiché : ${displayName}` : null,
    `Email : ${email || "—"}`,
    products && adminKind === "Suggestion" ? `Suggestion : ${products}` : null,
    "",
    String(s?.message || ""),
    "",
  ]
    .filter(Boolean)
    .join("\n");
  if (!email) return "";
  return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(subjectBase)}&body=${encodeURIComponent(body)}`;
}
